export default "__VITE_ASSET__f72e814f__"